module.exports = __webpack_public_path__ + "src/assets/textures/leaves/peanut_leaf_opacity_map.jpg";